export default __webpack_public_path__ + "static/media/headerimg-new.54a8525e.jpg";